import { Utils } from '@everyboard/lib';
import { DiaballikMoveGenerator, DiaballikMoveInConstruction } from './DiaballikMoveGenerator';
export class DiaballikFilteredMoveGenerator extends DiaballikMoveGenerator {
    moveLength;
    constructor(moveLength, avoidDuplicates = true) {
        super(avoidDuplicates);
        this.moveLength = moveLength;
        Utils.assert(1 <= moveLength && moveLength <= 3, 'Diaballik moves should be of length [1,3]');
    }
    /**
     * Implemented similarly as DiaballikMoveGenerator, but only generates moves containing exactly 3 sub moves.
     */
    getListMoves(node, _config) {
        const emptyMove = new DiaballikMoveInConstruction([], node.gameState, node.gameState);
        let movesInConstruction = [emptyMove];
        for (let i = 0; i < this.moveLength; i++) {
            let nextMovesInConstruction = [];
            for (const move of movesInConstruction) {
                nextMovesInConstruction = nextMovesInConstruction.concat(this.addAllPossibleSubMoves(move));
            }
            movesInConstruction = nextMovesInConstruction;
        }
        return movesInConstruction.map(DiaballikMoveInConstruction.finalize);
    }
}
